import React from 'react';
import * as R from 'ramda';
import { dateToString, formatAmount } from '../../../../utils/misc';
import InvoicePartner from '../../../../constants/models/invoicePartner';

export const PaymentTableRow = ({ invoice, setSelectedInvoice, partner, etablissement }) => {
    return (
        <div className="card p-2 mt-1">
            <div className="row gx-2 gy-1 align-items-center">
                <div className="col">
                    <div className="h5 ls-1 my-auto text-truncate o-50">{invoice.number}</div>
                </div>
                <div className="col">
                    <div className="h5 ls-1 my-auto text-truncate">{R.isNil(invoice.etablissement) ? '-' : invoice.etablissement}</div>
                </div>
                <div className="col col-md-2">
                    <div className="h5 ls-1 my-auto o-70 container-tiny">{dateToString(invoice.date)}</div>
                </div>
                <div className="col text-md-right">
                    <div className="h5 ls-1 my-auto container-press ml-auto">{invoice.totalToPay !== '' ? formatAmount(invoice.totalToPay) + " €" : ""}</div>
                </div>
                <div className="col text-md-right">
                    <div className="h5 ls-1 my-auto container-press ml-auto">{invoice.totalToBill !== '' ? formatAmount(invoice.totalToBill / 1.2) + " €" : ""}</div>
                </div>
                <div className="col-12 d-md-none">
                    <hr className="my-0" />
                </div>
                <div className="col-12 col-md-3 col-xl ml-auto flex-row justify-content-md-end">
                    {
                        !invoice.paid ?
                            (() => {
                                switch (invoice.status) {
                                    case "new":
                                    case "retry3":
                                    case "retry7":
                                        return <div className="badge alert-bagde text-uppercase btn-alert-danger font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">en Paiement</span></div>;

                                    case "canceled":
                                        return <div className="badge alert-bagde text-uppercase btn-dim font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">Annulé</span></div>;

                                    case "unpaid":
                                        return <div className="badge alert-bagde text-uppercase btn-alert-danger font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">Echoué</span></div>;

                                    default:
                                        return <div className="badge alert-bagde text-uppercase btn-dim font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">Inconnu</span></div>;
                                }

                            })()

                            :
                            <React.Fragment>
                                {/* <div className="badge alert-bagde text-uppercase btn-alert-danger font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">A payer</span></div> */}
                                <div className="badge alert-bagde text-uppercase btn-alert-success font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate"><span className="aling-middle text-truncate">Payé</span></div>
                                {/* <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" data-toggle="modal" data-target="#paySummary" onClick={() => setSelectedInvoice(new InvoicePartner(invoice))}>
                                    <i className="eva eva-eye-outline align-middle h4 lh-1 m-auto" data-toggle="tooltip" title="Voir le détail" data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'></i>
                                </button> */}
                                <div className="dropdown">
                                    <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" id="optionsDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i className="eva eva-more-horizontal-outline align-middle h4 lh-1 m-auto"></i>
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-right border-none paper-shadow rounded-sm p-2" aria-labelledby="optionsDropdown">
                                        {
                                            invoice.issuerId !== etablissement.id && invoice.issuerId !== partner.id ?
                                                <a href={invoice.pdfUrl} target="_blank" rel="noopener noreferrer" className="dropdown-item fs-3 px-2 rounded-sm"><i className="eva eva-file-text-outline align-middle fs-sm lh-1 mr-2"></i><span className="align-middle o-70 o-100--hover">Télécharger la facture</span></a>
                                                :
                                                <button type="button" className="dropdown-item fs-3 px-2 rounded-sm"><i className="eva eva-checkmark-circle-outline align-middle fs-sm lh-1 mr-2 text-success"></i><span className="align-middle o-70 o-100--hover">Marquer comme payé</span></button>
                                        }
                                    </div>
                                </div>
                            </React.Fragment>
                    }


                </div>
            </div>
        </div>
    );
};

